import React from 'react';
import Orders from '../Orders';

export default function Home(): React.ReactNode | null {
  return (
    <Orders />
  );
}
